export default "/_next/static/assets/ClearSans-Bold_7e54b34967b56e4ef1a9d4b9d974c36d.woff2";